module.exports = __webpack_public_path__ + "img/HDTOOL.c3a042f2.png";